export default __webpack_public_path__ + "static/media/icon_analytics.a4aac1b4.svg";